export default {"src":"/_next/static/media/G_small.8fc3cd69.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};